<template>
  <div>
  <v-info-form :title="title" @close="cancel()">
        <v-card-text>
          <v-layout column>
            <v-flex>
             Номер государственной регистрации:
             <b><a :href="getHref()" target="_blank">{{item.registrationNumber}}</a>
             </b>
            </v-flex>
            <v-flex>
             с <b>{{formats.blank(item.registrationDate, formats.formatDate)}}</b>
             <span v-show="item.expirationDate"> по <b>{{formats.blank(item.expirationDate, formats.formatDate)}}</b> </span>
             <b>
              <span v-if="item.actual" v-html="formats.formatSuccessHtml('- актуальный')"/>
              <span v-if="!item.actual" v-html="formats.formatErrorHtml('- не актуальный')"/>
             </b>
            </v-flex>
            <v-flex>
              Описание: <b>{{formats.blank(item.description)}}</b>
            </v-flex>
            <v-flex>
              Изображение (воспроизведение) товарного знака, знака обслуживания:
              <div>
                <span v-if="!getImageUrl(item)">Изображение не обнаружено </span>
                <span v-if="getAudioUrl(item)">
                  <audio controls>
                    <source :src="getAudioUrl(item)" type="audio/mpeg">
                    Your browser does not support the audio element.
                  </audio>
                </span>
               <a v-if="getImageUrl(item) && !item.sound" :href="getStreamUrl(item)" target="_blank">
              <img width="60%" :src="getImageUrl(item)"/>
              </a> 
              </div>
            </v-flex>
            <v-flex>
              Классы МКТУ и перечень товаров и/или услуг:
              <div>
              <b>{{formats.blank(item.nice)}}</b>
              </div>
            </v-flex>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-info-form>
</div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import server from '../../api/server'
  import vInfoForm from '../common/InfoForm'

  export default {
    name: 'v-trademark-form',
    mixins: [apimix],
    components: {vInfoForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {}
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: () => {}
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
      if (!this.model) {
        this.item = this.getItemNew()
      } else {
        this.item = this.model
      }
    },
    watch: {
      model: function (newVal, oldVal) {
        if (!newVal) {
          this.item = this.getItemNew()
        } else {
          this.item = newVal
        }
      }
    },
    computed: {
      ...mapGetters({
      }),
      title () {
        return `Товарный знак ${this.item.registrationNumber ? this.item.registrationNumber : ''}`
      }
    },
    methods: {
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          registrationNumber: null,
          startDate: null,
          finishDate: null,
          activities: [],
          locations: [],
          issued: {
            date: null,
            org: null
          },
          paused: null
        }
      },
      getImageUrl (item) {
        if (!item || !item.imageUrl) {
          return null
        }
        return `${server.getBaseUrl()}/openapi/trademarks/${item.registrationNumber}/preview`
      },
      getAudioUrl (item) {
        if (!item || !item.imageUrl || !item.sound) {
          return null
        }
        return `${server.getBaseUrl()}/openapi/trademarks/${item.registrationNumber}/stream`
      },
      getStreamUrl (item) {
        if (!item || !item.imageUrl) {
          return null
        }
        return `${server.getBaseUrl()}/openapi/trademarks/${item.registrationNumber}/stream`
      },
      getHref () {
        if (!this.item || !this.item.publicationUrl) {
          return ''
        }
        return this.item.publicationUrl
      }
    }

  }

</script>




// WEBPACK FOOTER //
// TrademarkForm.vue?601565a4